// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__A0EJd","count":"Post_count__1Uc43"};